const AboutText = () => {
  const getSpans = (text) => {
    let spans = [];
    for (let i = 0; i < text.length; i++) {
      spans.push(
        <span className="t" key={i.toString()}>
          {text[i]}
        </span>
      );
    }
    return spans;
  };
  return (
    <section className="about-text">
      <h1 className="about-title">{getSpans("About Three.js")}</h1>
      <div className="about-contents">
      Three. JS is a cross-browser JavaScript library/API which is used to create and animate 3D computer graphics to display in a web browser. It's one type of a single JavaScript file and includes features like effects, scenes, cameras, lights, sky, materials, meshes, shaders, animations, and 3D objects.
        <br />
        <br /> Three. JS is a cross-browser JavaScript library/API which is used to create and animate 3D computer graphics to display in a web browser. It's one type of a single JavaScript file and includes features like effects, scenes, cameras, lights, sky, materials, meshes, shaders, animations, and 3D objects.
      </div>
    </section>
  );
};

export default AboutText;
